var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"content"}},[_c('div',{staticClass:"centered"},[_c('img',{staticClass:"logo",attrs:{"src":require("../../public/logo.png"),"alt":"Logo"}}),_c('div',{staticClass:"loading-bar"},[_c('div',{staticClass:"blue-bar"})])])])
}]

export { render, staticRenderFns }